export default "__VITE_ASSET__CePOS9ld__"